import { Directive, Input, OnDestroy, OnInit, ViewContainerRef, inject } from '@angular/core';

import { CustomTableCell } from '../components/table/table.interface';

@Directive({
    selector: '[zciCustomCell]',
})
export class CustomCellDirective implements OnInit, OnDestroy {
    private vcr = inject(ViewContainerRef);

    customCell: CustomTableCell;

    @Input() set zciCustomCell(customCell) {
        this.customCell = customCell;
    }

    ngOnInit() {
        const componentRef = this.vcr.createComponent(this.customCell.component);
        if (this.customCell.data) {
            Object.entries(this.customCell.data).forEach(([key, value]: [string, any]) => {
                componentRef.instance[key] = value;
            });
        }
    }

    ngOnDestroy() {
        this.vcr.clear();
    }
}
